/**
 * Utility function to filter strong matches consistently across the application
 * @param items - Array of items to filter
 * @returns Array of items that are strong matches
 */
export const filterStrongMatches = (items: any[]): any[] => {
  if (!Array.isArray(items)) return [];
  
  return items.filter((item: any) => {
    // Check multiple possible match level formats
    const matchLevel = item?.match?.level 
    
    // Check multiple possible strong match values
    const isStrong = matchLevel === 'Strong' 
    
    return isStrong;
  });
};

/**
 * Utility function to check if a single item is a strong match
 * @param item - Item to check
 * @returns boolean indicating if the item is a strong match
 */
export const isStrongMatch = (item: any): boolean => {
  const matchLevel = item?.match?.level || item?.matchLevel || item?.level;
  
  return matchLevel === 'Strong' 
}; 